import React from 'react';
import './Spinner.css'; // Add styles for your spinner
import { useTheme } from '@mui/material/styles';

const Spinner = () => {
    
    const theme = useTheme(); // Access the theme object
    const primaryColor = theme.palette.primary.main; 
    return (
    <div className="spinner-overlay">
        <div className="spinner" style={{ borderLeftColor: primaryColor }} />
    </div>
)};

export default Spinner;
